import React from 'react';
import { Link } from 'react-router-dom';

const AdBanner = ({ image, title, subtitle, ctaText, ctaLink, accent, position }) => {
  return (
    <section className="px-[5%] py-8">
      <div className="max-w-[1400px] mx-auto">
        <Link
          to={ctaLink || '#'}
          className="group relative rounded-3xl overflow-hidden h-[280px] max-[900px]:h-[220px] max-[600px]:h-[160px] flex items-center justify-end cursor-pointer transition-all duration-500 hover:shadow-[0_30px_80px_rgba(0,0,0,0.7)] hover:scale-[1.01]"
          style={{
            background: `url(${image}) center/cover no-repeat`,
          }}
        >
          {/* Background image zoom effect */}
          <div className="absolute inset-0 transition-transform duration-700 group-hover:scale-[1.05] pointer-events-none" style={{ background: `url(${image}) center/cover no-repeat` }} />

          {/* Dark overlay gradient — stronger for text contrast */}
          <div
            className="absolute inset-0"
            style={{
              background: `linear-gradient(135deg, rgba(6,12,24,0.9) 0%, rgba(6,12,24,0.5) 50%, rgba(6,12,24,0.2) 100%)`,
            }}
          />

          {/* Animated accent bar on left */}
          <div
            className="absolute left-0 top-0 bottom-0 w-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
            style={{
              background: `linear-gradient(180deg, transparent, ${accent}, transparent)`,
            }}
          />

          {/* Hover glow effect — more prominent */}
          <div
            className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
            style={{
              background: `radial-gradient(ellipse at 25% 50%, ${accent}25 0%, transparent 65%)`,
            }}
          />

          {/* Premium badge */}
          <div className="absolute top-4 right-4 z-20 px-3 py-1.5 rounded-full text-[11px] font-extrabold tracking-[1px] uppercase border"
            style={{ background: `${accent}18`, color: accent, borderColor: `${accent}50` }}>
            🎯 Limited Offer
          </div>

          {/* Border with accent glow */}
          <div
            className="absolute inset-0 rounded-3xl border border-white/[0.15] pointer-events-none transition-all duration-500 group-hover:border-white/[0.3]"
            style={{
              boxShadow: `inset 0 0 20px ${accent}20`,
            }}
          />

          {/* Content */}
          <div className="relative z-10 p-8 max-w-[55%] max-[900px]:p-6 max-[900px]:max-w-[60%] max-[600px]:p-4 max-[600px]:max-w-[70%]">
            {/* Title with gradient text on hover */}
            {title && (
              <h3 className="text-[42px] font-black text-white leading-[1.1] mb-2.5 -tracking-[1px] max-[900px]:text-[28px] max-[600px]:text-[18px] transition-all duration-300 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-white/70 group-hover:bg-clip-text"
              >
                {title}
              </h3>
            )}

            {/* Subtitle */}
            {subtitle && (
              <p className="text-[#8896a6] text-lg leading-[1.6] mb-6 max-[900px]:text-base max-[900px]:mb-4 max-[600px]:text-sm max-[600px]:mb-3 transition-colors duration-300 group-hover:text-[#a9c0d4]">
                {subtitle}
              </p>
            )}

            {/* CTA Button with enhanced hover state */}
            {ctaText && (
              <button
                className="px-8 py-3 rounded-xl border-none text-[#060c18] text-[15px] font-extrabold cursor-pointer whitespace-nowrap transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_16px_50px_rgba(0,0,0,0.5)] max-[900px]:px-6 max-[900px]:py-2.5 max-[900px]:text-[13px] max-[600px]:px-4 max-[600px]:py-2 max-[600px]:text-[11px] group-hover:scale-105"
                style={{
                  background: `linear-gradient(135deg, ${accent}, ${accent}ee)`,
                  boxShadow: `0 8px 24px ${accent}50`,
                }}
              >
                {ctaText} →
              </button>
            )}
          </div>

          {/* Animated shimmer sweep on hover */}
          <div
            className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
            style={{
              background: 'linear-gradient(105deg, transparent 20%, rgba(255,255,255,0.04) 50%, transparent 80%)',
            }}
          />

          {/* Bottom accent line */}
          <div
            className="absolute bottom-0 left-0 right-0 h-[3px] origin-left transition-all duration-500 group-hover:scale-x-100"
            style={{
              background: `linear-gradient(90deg, ${accent}00, ${accent}, ${accent}00)`,
              scaleX: 0.5,
            }}
          />
        </Link>
      </div>
    </section>
  );
};

export default AdBanner;
